<template>
    <div v-wechat-title="title">
        <crud-facecade
            ref="package-list"
            :url="url"
            :tableHeight="tableHeight"
            :columns="listableColumn"
            :buttons="[]"
            dialogWidth="95%"
            :addButton="{ enabled: false, label: '器械入库', permission: 'package:create', emit: 'LoadingPackageInView' }"
            :updateButton="{ label: '查看', permission: 'package:update', emit: 'LoadingPackageOutView' }"
            :filterSpan="[14, 6]"
            @LoadingPackageInView="LoadingPackageInView('hand')"
            @LoadingPackageOutView="LoadingPackageOutView"
        >
            <slot slot="filter">
                <el-col :md="8" :lg="6" :xl="4" class="align-left">
                    <item-input type="select" v-model="dic_operating_ward_id" :options="operation_ward_auth" placeholder="请选择区域"></item-input>
                </el-col>
            </slot>
            <slot slot="filter-after">
                <el-button has-permission="default" type="primary" size="mini" @click="LoadingPackageInView('scan')">器械扫码入库</el-button>
                <el-button has-permission="package:create" type="primary" size="mini" @click="LoadingPackageInView('hand')">器械入库</el-button>
            </slot>
        </crud-facecade>

        <!-- 器械入库 -->
        <cus-dialog class="form-table-h380" title="器械入库" :visible.sync="packageIn.dialogFormVisible" @confirm="SaveInStore" width="95%" :okVisible="false" :okOnceVisible="true">
            <cus-form ref="form-instore" :data="packageIn" :columns="inStoreColumns" @extrabutton-click="ExtraButtonClick" @confirm="inStore" @new-scan="inStoreByScan"></cus-form>
        </cus-dialog>
        <!-- 器械出库 -->
        <el-dialog class="form-table-h500" title="器械包查看" :visible.sync="packageOut.dialogFormVisible" :close-on-click-modal="false" width="95%">
            <cus-form :data="packageOut" :columns="packageListColumn2" @extrabutton-click="ExtraButtonClick2"></cus-form>
        </el-dialog>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `InstrumentStore`,
    props: {},
    data() {
        return {
            title: `器械入出库`,
            url: {
                baseURL: `/api/Nursing/UsePackage`,
                get: () => {
                    return this.loadInstorePackages()
                }
            },
            instore_style: `hand`,
            enum_package: [],
            o_dic_operating_ward_id: undefined,
            issetoperatingward: false,
            packageIn: {
                dialogFormVisible: false,
                dic_operating_ward_id: undefined,
                package_id: undefined,
                disinfecting_time: _.now(),
                quantity: 1,
                packages: [],
                activePackage: undefined,
                instruments: []
            },
            packageOut: {
                dialogFormVisible: false,
                packages: [],
                activePackage: undefined,
                instruments: []
            },
            package_list_title: { content: `器械包列表`, position: `top` },
            package_detail_quantity_label: `数量(总计：0个)`
        }
    },
    computed: {
        ...mapGetters([`operation_ward_auth`, `active_ward`, `screenHeight`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        dic_operating_ward_id: {
            get: function() {
                if (!this.issetoperatingward && this.active_ward && _.startsWith(this.active_ward.value, `ow_`)) {
                    this.o_dic_operating_ward_id = this.active_ward.origion
                }
                return this.o_dic_operating_ward_id
            },
            set: function(v) {
                this.o_dic_operating_ward_id = v
                this.issetoperatingward = true
            }
        },
        packageListColumn2() {
            return [
                {
                    type: `table2`,
                    prop: `packages`,
                    label: this.package_list_title,
                    options: this.tablePackageColumns2,
                    default: [],
                    colspan: 18
                },
                {
                    type: `table2`,
                    prop: `instruments`,
                    label: { content: `器械包详情`, position: `top` },
                    options: [
                        {
                            type: `string`,
                            prop: `name`,
                            label: `器械名称`,
                            isListable: true
                        },
                        {
                            type: `string`,
                            prop: `quantity`,
                            label: this.package_detail_quantity_label,
                            isListable: true
                        }
                    ],
                    default: [],
                    colspan: 6
                }
            ]
        },
        packageListColumn() {
            return [
                {
                    type: `table2`,
                    prop: `packages`,
                    label: this.package_list_title,
                    options: this.tablePackageColumns,
                    default: [],
                    colspan: 18
                },
                {
                    type: `table2`,
                    prop: `instruments`,
                    label: { content: `器械包详情`, position: `top` },
                    options: [
                        {
                            type: `string`,
                            prop: `name`,
                            label: `器械名称`,
                            isListable: true
                        },
                        {
                            type: `string`,
                            prop: `quantity`,
                            label: this.package_detail_quantity_label,
                            isListable: true
                        }
                    ],
                    default: [],
                    colspan: 6
                }
            ]
        },
        inStoreColumns() {
            let me = this
            if (this.instore_style == `hand`) {
                return [
                    {
                        type: `select`,
                        prop: `dic_operating_ward_id`,
                        label: `手术区`,
                        options: this.operation_ward_auth,
                        colspan: 4,
                        default: this.dic_operating_ward_id
                    },
                    {
                        type: `select`,
                        prop: `package_id`,
                        label: `器械包`,
                        colspan: 4,
                        options: this.enum_package,
                        change: (that, { row }) => {
                            if (row.package_id && row.package_id > 0) {
                                let selectrow = _.find(me.enum_package, { value: row.package_id })
                                me.$set(row, `is_external`, selectrow && selectrow.is_external || false)
                            }
                        },
                        validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                    },
                    {
                        type: `select`,
                        prop: `is_external`,
                        label: `外来`,
                        options: `enum_bool`,
                        default: false,
                        readonly: function(that, { row, column, area }) {
                            if (row.package_id && row.package_id > 0) {
                                let selectrow = _.find(me.enum_package, { value: row.package_id })
                                return selectrow && selectrow.is_external || false
                            }
                            return false
                        },
                        colspan: 3,
                        validate: [{ required: true, message: `必填项目`, trigger: `change` }]
                    },
                    {
                        type: `number`,
                        prop: `quantity`,
                        label: `数量`,
                        default: 1,
                        colspan: 3,
                        validate: [{ required: true, message: `必填项目`, trigger: `change` }]
                    },
                    {
                        type: `date`,
                        prop: `disinfecting_time`,
                        label: `消毒日期`,
                        default: _.now(),
                        colspan: 4
                    },
                    {
                        type: `buttongroup`,
                        prop: `instore`,
                        label: ``,
                        colspan: 2,
                        readonly: false,
                        options: [
                            {
                                // class:"is-plain",
                                label: `添加`,
                                type: `primary`,
                                emit: `inStoreConfirm`,
                                permission: `default`
                            }
                        ]
                    }
                ].concat(this.packageListColumn)
            } else {
                return [
                    {
                        type: `scan`,
                        prop: `internal_code`,
                        label: `条码号`,
                        colspan: 8,
                        placeholder: `请扫码或者手动输入条码号`,
                        autofocus: true,
                        change: function($that, { row }) {
                            // if (!$that.emitNewScan) {
                            //     $that.emitNewScan = _.debounce(function() {
                            //         $that.$emit(`new-scan`, row)
                            //     }, 1000)
                            // }
                            // $that.emitNewScan()
                            // 解决上面扫码获取条形码号不变(第一次条码号)的问题
                            $that.$emit(`new-scan`, row)
                        },
                        config: {
                            autofocus: true
                        }
                    }
                ].concat(this.packageListColumn)
            }
        },
        listableColumn() {
            return [
                {
                    type: `string`,
                    prop: `code`,
                    label: `器械包编码`,
                    isListable: true,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `name`,
                    label: `器械包`,
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `is_external`,
                    label: `外来`,
                    width: `80`,
                    options: `enum_bool`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `quantity`,
                    label: `库存量`,
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `has_expired`,
                    label: `存在过期包`,
                    isListable: true,
                    options: `enum_bool`
                },
                {
                    type: `datetime`,
                    prop: `last_accept_date`,
                    label: `最近入库时间`,
                    width: `180`,
                    isListable: true,
                    isExpand: false,
                    sortable: `desc`
                }
            ]
        },
        tablePackageColumns() {
            return [
                {
                    type: `select`,
                    prop: `dic_instrument_package_id`,
                    label: `器械包名称`,
                    isListable: true,
                    isKey: true,
                    // readonly:false,
                    options: this.enum_package
                },
                {
                    type: `select`,
                    prop: `dic_operating_ward_id`,
                    label: `手术区`,
                    options: this.operation_ward_auth,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `outbound_order_id`,
                    label: `出库单`,
                    isListable: true,
                    readonly: false
                },
                {
                    type: `string`,
                    prop: `internal_code`,
                    label: `条码号`,
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `is_external`,
                    label: `外来`,
                    width: `80`,
                    options: `enum_bool`,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `stock_in_time`,
                    label: `入库时间`,
                    isListable: true
                },
                {
                    type: `date`,
                    prop: `clean_date`,
                    label: `消毒日期`,
                    isListable: true
                },
                {
                    type: `date`,
                    prop: `valid_date`,
                    label: `失效日期`,
                    isListable: true
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    isListable: true,
                    readonly: false,
                    options: [
                        {
                            class: `is-plain`,
                            label: `移除`,
                            type: `danger`,
                            emit: `remove`,
                            permission: `default`
                        }
                    ]
                }
            ]
        },
        tablePackageColumns2() {
            return [
                {
                    type: `select`,
                    prop: `dic_operating_ward_id`,
                    label: `手术区`,
                    options: this.operation_ward_auth,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `outbound_order_id`,
                    label: `出库单`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `internal_code`,
                    label: `条码号`,
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `is_external`,
                    label: `外来`,
                    width: `80`,
                    options: `enum_bool`,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `stock_in_time`,
                    label: `入库时间`,
                    isListable: true
                },
                {
                    type: `date`,
                    prop: `clean_date`,
                    label: `消毒日期`,
                    isListable: true
                },
                {
                    type: `date`,
                    prop: `valid_date`,
                    label: `失效日期`,
                    isListable: true
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    isListable: true,
                    readonly: false,
                    options: [
                        {
                            class: `is-plain`,
                            label: `移除`,
                            type: `danger`,
                            emit: `remove`,
                            permission: `default`
                        }
                    ]
                }
            ]
        }
    },
    created() {
        this.$store.dispatch(`ADD_OPERATION_WARD_AUTH`)
        this.loadPackages()
    },
    methods: {
        loadInstorePackages() {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/Nursing/UsePackage/Get`)
                req.then(data => {
                    resolve(_.filter(data, { dic_operating_ward_id: this.dic_operating_ward_id }))
                }).catch(e => reject(e))
            })
        },
        loadPackages() {
            let that = this
            let req = that.myaxios.get(`/api/AcisSystem/Package/Get`)
            req.then(data => {
                that.enum_package = _.filter(data, { is_deleted: false }).map(d => {
                    return {
                        value: d.id,
                        label: d.name,
                        jianpin: d.abbr,
                        is_external: d.is_external
                    }
                })
            }).catch(e => {
                that.enum_package = []
            })
        },
        LoadingPackageInView(style) {
            this.instore_style = style
            this.package_list_title = { content: `器械包列表`, position: `top` }
            this.package_detail_quantity_label = `数量(总计：${0}个)`
            this.packageIn.packages = []
            this.packageIn.instruments = []
            this.packageIn.dic_operating_ward_id = this.dic_operating_ward_id
            this.packageIn.dialogFormVisible = true
        },
        LoadingPackageOutView({ row }) {
            let that = this
            // console.log(row)
            let req1 = that.myaxios.get(`/api/Nursing/UsePackage/Get/${row.id}`)
            let req2 = that.myaxios.get(`/api/AcisSystem/Package/Get/${row.id}`)
            that.myaxios
                .all(req1, req2)
                .then(([packages, pac]) => {
                    that.package_list_title = { content: row.name + (row.is_external ? `【外】` : ``), position: `top` }
                    that.packageOut.packages = _.filter(packages, { dic_operating_ward_id: this.dic_operating_ward_id }).map(d => {
                        d.class_name = this.$moment(d.valid_date).isAfter(this.$moment()) ? `` : `outofdate` // 超期的日期显示红色 ，css控制
                        return d
                    })
                    that.packageOut.instruments = pac && pac.instruments
                    that.packageOut.dialogFormVisible = true
                    let sumCount = _.sumBy(that.packageOut.instruments, function(o) {
                        return o.quantity
                    })
                    that.package_detail_quantity_label = `数量(总计：${sumCount}个)`
                })
                .catch(e => {
                    console.log(e)
                })
        },
        SaveInStore() {
            // this.packageIn.dialogFormVisible = false
            // this.$message.success("入库成功")
            let that = this
            let req = this.myaxios.post(
                `/api/Nursing/UsePackage/Post`,
                that.packageIn.packages.map(p => {
                    return {
                        id: 0,
                        internal_code: p.internal_code,
                        dic_instrument_package_id: p.dic_instrument_package_id,
                        // "enum_package_status": 0,
                        valid_date: p.valid_date,
                        dic_operating_ward_id: p.dic_operating_ward_id,
                        clean_date: p.clean_date,
                        is_external: p.is_external,
                        outbound_order_id: p.outbound_order_id
                    }
                })
            )
            req.then(data => {
                if (data && data !== ``) {
                    this.$message.info(`出库单存在未入库包【${data}】`)
                }
                this.packageIn.dialogFormVisible = false
                this.$refs[`package-list`].ReloadListData()
            }).catch(e => {
                console.log(e)
            })
        },
        inStoreConfirm() {
            this.$refs[`form-instore`].confirm()
        },
        inStore(row) {
            let that = this
            let req = that.myaxios.put(`/api/Nursing/UsePackage/In?quantity=${row.quantity}`, {
                dic_instrument_package_id: row.package_id,
                dic_operating_ward_id: row.dic_operating_ward_id,
                is_external: row.is_external,
                clean_date: that.$moment(row.disinfecting_time).format(`YYYY/MM/DD HH:mm:ss`)
            })
            req.then(data => {
                that.dic_operating_ward_id = row.dic_operating_ward_id
                that.packageIn.packages.push(...data)
                let active = _.last(data)
                that.rowClick({ row: active })
            }).catch(e => {
                console.log(e)
            })
        },
        inStoreByScan(row) {
            let that = this
            let req = that.myaxios.put(`/api/Nursing/UsePackage/Scan?code=${row.internal_code}&operatingWardId=${row.origion.dic_operating_ward_id}`)
            req.then(data => {
                if (data && data.length > 0) {
                    // 清空扫码框
                    that.$refs[`form-instore`].$refs[`ItemInput`][0].scan_val = ``
                    // 判断是否已经包含了
                    let scanItem = data[0]
                    const arr = _.find(that.packageIn.packages, { 'internal_code': scanItem.internal_code })
                    if (arr) {
                        that.$message.warning(`扫描二维码列表中已包含,请勿重复扫码！`)
                        return
                    }
                    that.packageIn.packages.push(...data)
                    let active = _.last(data)
                    that.rowClick({ row: active })
                    that.loadPackages()
                }
            }).catch(e => {
                console.log(e)
                that.$message.warning(e)
                // 清空扫码框
                that.$refs[`form-instore`].$refs[`ItemInput`][0].scan_val = ``
            })
        },
        remove({ index, row }) {
            // 移除一行
            let that = this
            that.packageIn.packages.splice(index, 1)
            if (that.packageIn.packages && that.packageIn.packages.length == 0) {
                that.packageIn.instruments = []
            } else {
                this.rowClick({ row: that.packageIn.packages[0] })
            }
        },
        ExtraButtonClick(target) {
            this[target.emit](target)
        },
        ExtraButtonClick2({ emit, row, index }) {
            // 真实出库
            let that = this
            if (emit == `remove`) {
                this.$confirm(`此操作将永久删除该记录, 是否继续?`, `提示`, {
                    confirmButtonText: `确定`,
                    cancelButtonText: `取消`,
                    type: `warning`,
                    closeOnClickModal: false
                })
                    .then(() => {
                        let req = that.myaxios.put(`/api/Nursing/UsePackage/Out/${row.id}`)
                        req.then(data => {
                            that.packageOut.packages.splice(index, 1)
                            if (that.packageOut.packages && that.packageOut.packages.length == 0) {
                                that.packageOut.instruments = []
                            } else {
                                this.rowClick({ row: that.packageOut.packages[0] })
                            }
                            that.$message.success(`出库成功`)
                            this.$refs[`package-list`].ReloadListData()
                        }).catch(e => {
                            console.log(e)
                        })
                    })
                    .catch(e => {})
            }
        },
        rowClick({ row }) {
            let that = this
            if (that.packageIn.activePackage == row.dic_instrument_package_id && this.packageIn.instruments.length > 0) return
            that.packageIn.activePackage = row.dic_instrument_package_id
            let req2 = that.myaxios.get(`/api/AcisSystem/Package/Get/${row.dic_instrument_package_id}`)
            req2.then(instrumentPackage => {
                that.packageIn.instruments = (instrumentPackage && instrumentPackage.instruments) || []
                let sumCount = _.sumBy(that.packageIn.instruments, function(o) {
                    return o.quantity
                })
                that.package_detail_quantity_label = `数量(总计：${sumCount}个)`
            }).catch(e => {
                console.log(e)
            })
        }
    },
    watch: {
        // 'packageIn.dic_operating_ward_id'(){
        //   this.$refs["package-list"].ReloadListData()
        // },
        dic_operating_ward_id() {
            this.$refs[`package-list`].ReloadListData()
        }
    }
}
</script>
<style lang="less">
.outofdate .valid_date {
    color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/Dictionary/Instrument/InStore.vue